module.exports = __webpack_public_path__ + "fonts/ClearSans-Regular-webfont207557cd41a54883b13627dcfd0240aa.eot";